import { useSelector } from 'react-redux';
import { hasUserPermissions } from '../../helpers/utils/permissoes';

export const PERMISSAO_PESQUISAR_WEBSERVICE_DEVEDOR = 703;

/**
 * Gate de permissão do botão "PESQUISA WEB SERVICE" da aba Devedor
 * (AW2-1134 Etapa 10) — mesma permissão já checada em produção
 * (`DadosDevedor.jsx`, `permissoesDevedor.pesquisarWebService =
 * hasUserPermissions(703)`).
 *
 * Mesmo padrão de `usePodeGerenciarDevedor.js` (permissão 702) — hook
 * reativo via `useSelector`, não `useMemo(..., [])` como a produção real,
 * para não travar no snapshot da 1ª renderização caso a permissão do
 * usuário logado mude durante a sessão (regra já documentada em
 * `src/prototipo/CLAUDE.md`). 2ª ocorrência do mesmo padrão de hook de
 * permissão nesta aba — aceitável não extrair um hook genérico
 * `usePermissao(codigo)` ainda ("2x aceitável, 3ª extrai").
 *
 * Gate apenas cosmético — a autorização real é validada no backend de
 * `constultarDadosComplementaresDevedorWebserviceExterno`.
 */
export default function usePodePesquisarWebServiceDevedor() {
  useSelector(state => state.authentication.userInformation.permissoes);
  return hasUserPermissions(PERMISSAO_PESQUISAR_WEBSERVICE_DEVEDOR);
}
